import React from "react";

import { withTranslation } from "react-i18next";
import { Alert, Button, Card, Form, InputGroup } from "react-bootstrap";
import {
  faTimes,
  faEdit,
  faDownload,
  faFile,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/fontawesome-free-solid";
import Switch from "react-switch";
import ValidationHelper from "../../../../../../helpers/ValidationHelper";
import equals from "fast-deep-equal";

class SEBSettingsSection extends React.Component {
  constructor(props) {
    super(props);
    this.fileReader = new FileReader();
    this.validationDefinition = this.getValidation();

    this.state = {
      validation: ValidationHelper.getValidation(this.validationDefinition),
      isInvalidSEBConfiguration: false,
      editLMSExaminationKey: false,
      useOwnSEBTemplate:
        ValidationHelper.isFieldDefined(
          this.props.configuration,
          "seb_configuration"
        ) && this.props.configuration.seb_configuration.length > 0,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleUpload = this.handleUpload.bind(this);
    this.handleReadData = this.handleReadData.bind(this);
    this.getValidation = this.getValidation.bind(this);

    this.fileReader.onload = this.handleReadData;
  }

  componentDidMount() {
    this.validationDefinition = this.getValidation();
    this.setState({
      validation: ValidationHelper.getValidation(this.validationDefinition)
    })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!equals(prevProps.configuration, this.props.configuration)) {
      this.validationDefinition = this.getValidation();
      this.setState({
        validation: ValidationHelper.getValidation(this.validationDefinition)
      })
    }
  }

  getValidation(){
    return {
      lms_examination_key: {
        defaultValue: ValidationHelper.isFieldDefined(
            this.props.configuration,
            "lms_examination_key"
        )
            ? this.props.configuration.lms_examination_key
            : "",
        initValid: true,
        rule: ValidationHelper.isSHA256,
      },
      seb_configuration: {
        defaultValue: ValidationHelper.isFieldDefined(
            this.props.configuration,
            "seb_configuration"
        )
            ? this.props.configuration.seb_configuration
            : "",
        initValid: true,
        rule: ValidationHelper.isString,
      },
      quit_password: {
        defaultValue:
            ValidationHelper.isFieldDefined(
                this.props.configuration,
                "quit_password"
            ) && this.props.configuration.quit_password.length > 0
                ? this.props.configuration.quit_password
                : (Math.random() + 1).toString(36).substring(8),
        initValid: true,
        rule: (value) => ValidationHelper.isString(value) && value.length > 0,
      }
    };
  }

  async handleReadData() {
    const xmlStartSequence = "<?xml";
    this.setState({ isInvalidSEBConfiguration: false });
    try {
      const resource = await fetch(this.fileReader.result);
      const dataBlob = await resource.blob();
      const gzipBlob = dataBlob.slice();
      let possibleXMLSEBConfiguration = await dataBlob.text();
      if (possibleXMLSEBConfiguration.substring(0, 5) !== xmlStartSequence) {
        // It is not plain text -> Gzip compressed
        //eslint-disable-next-line
        const ds = new DecompressionStream("gzip");
        const decompressedStream = gzipBlob.stream().pipeThrough(ds);
        const responseBlob = await new Response(decompressedStream).blob();
        possibleXMLSEBConfiguration = await responseBlob.text();
        if (possibleXMLSEBConfiguration.substring(0, 5) !== xmlStartSequence) {
          this.setState({ isInvalidSEBConfiguration: true });
          return;
        }
      }
      this.setState({ isInvalidSEBConfiguration: false });
      this.handleChange({
        target: {
          name: "seb_configuration",
          value: btoa(possibleXMLSEBConfiguration),
        },
      });
      return;
    } catch (err) {
      console.error(err);
    }
    this.setState({ isInvalidSEBConfiguration: true });
  }

  handleUpload(event) {
    this.fileReader.readAsDataURL(event.target.files[0]);
  }

  handleChange(event) {
    const validation = ValidationHelper.update(event, this.state.validation);
    this.setState({
      validation: validation,
    }, () => {
      if (this.state.validation._isValid) {
        this.props.onUpdate(ValidationHelper.getData(validation));
      }
      this.props.onValid(validation._isValid);
    });
  }

  render() {
    const { t } = this.props;
    return (
      <>
        {this.props.securityLevel === 5 || this.props.securityLevel === 6 ? (
          <>
            <Form.Group controlId="formQuitPassword">
              <Form.Label>
                {t(
                  "SingleExamination.ConfigurationTab.WebConfiguration.QuitPassword"
                )}
              </Form.Label>
              <Form.Control
                type="text"
                name="quit_password"
                disabled={this.props.disabled}
                value={this.state.validation.quit_password.value}
                isInvalid={!this.state.validation.quit_password.isValid}
                onChange={this.handleChange}
              />
              <Form.Control.Feedback type="invalid">
                {t(
                  "SingleExamination.ConfigurationTab.WebConfiguration.ValidationError.QuitPassword"
                )}
              </Form.Control.Feedback>
            </Form.Group>
          </>
        ) : (
          ""
        )}
        <Form.Group controlId="formLMSExaminationKey" className="mb-3">
          <Form.Label>
            {t(
              "SingleExamination.ConfigurationTab.WebConfiguration.LMSExaminationKey"
            )}
          </Form.Label>
          <InputGroup>
            <Form.Control
              type="text"
              name="lms_examination_key"
              disabled={
                this.props.disabled || !this.state.editLMSExaminationKey
              }
              readOnly={!this.state.editLMSExaminationKey}
              value={this.state.validation.lms_examination_key.value}
              isInvalid={!this.state.validation.lms_examination_key.isValid}
              onChange={this.handleChange}
            />
            <Button
              onClick={() =>
                this.setState({
                  editLMSExaminationKey: !this.state.editLMSExaminationKey,
                })
              }
              className="btn btn-black"
              disabled={this.props.disabled}
              style={{
                borderBottomLeftRadius: "0px",
                borderTopLeftRadius: "0px",
              }}
            >
              {this.state.editLMSExaminationKey ? (
                <FontAwesomeIcon icon={faTimes} />
              ) : (
                <FontAwesomeIcon icon={faEdit} />
              )}
            </Button>
          </InputGroup>
          <Form.Control.Feedback type="invalid">
            {t(
              "SingleExamination.ConfigurationTab.WebConfiguration.ValidationError.LMSExaminationKey"
            )}
          </Form.Control.Feedback>
        </Form.Group>

        {this.props.securityLevel === 5 || this.props.securityLevel === 6 ? (
          <>
            <Form.Group
              controlId="formAllowOwnSEBTemplate"
              className="mt-0 mb-0"
            >
              <Form.Label>
                {t(
                  "SingleExamination.ConfigurationTab.WebConfiguration.UseOwnSEBConfigurationTemplate"
                )}{" "}
              </Form.Label>
              <Switch
                className="float-right"
                onColor="#54BF8D"
                disabled={this.props.disabled}
                checked={
                  this.state.useOwnSEBTemplate ||
                  this.state.validation.seb_configuration.value.length > 0
                }
                onChange={(state) => {
                  this.setState({ useOwnSEBTemplate: state });
                  if (!state) {
                    this.handleChange({
                      target: {
                        name: "seb_configuration",
                        value: "",
                      },
                    });
                  }
                }}
                height={18}
                width={40}
              />
            </Form.Group>
            {this.state.isInvalidSEBConfiguration ? (
              <Alert variant="danger">
                {t(
                  "SingleExamination.ConfigurationTab.WebConfiguration.InvalidSEBFile"
                )}
              </Alert>
            ) : (
              ""
            )}
            {this.state.useOwnSEBTemplate ? (
              this.state.validation.seb_configuration.value.length < 1 ? (
                <Form.Group>
                  <Form.File custom>
                    <Form.File.Input
                      onChange={this.handleUpload}
                      accept=".seb"
                    />
                    <Form.File.Label
                      data-browse={t(
                        "SingleExamination.ConfigurationTab.WebConfiguration.SEBFile"
                      )}
                    />
                  </Form.File>
                </Form.Group>
              ) : (
                <Card>
                  <Card.Body>
                    <FontAwesomeIcon icon={faFile} className="mr-2" />{" "}
                    {t(
                      "SingleExamination.ConfigurationTab.WebConfiguration.SEBConfigurationTemplateUploaded"
                    )}{" "}
                    <Button
                      onClick={() => {
                        this.handleChange({
                          target: {
                            name: "seb_configuration",
                            value: "",
                          },
                        });
                      }}
                      disabled={this.props.disabled}
                      className="btn-red btn-sm ml-2 floatRight"
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </Button>
                  </Card.Body>
                </Card>
              )
            ) : (
              ""
            )}
            <div>
              <hr />
              <Button
                onClick={() => this.props.onSEBConfigurationDownload()}
                disabled={this.props.isDirty}
                className="btn-green mt-2"
              >
                <FontAwesomeIcon icon={faDownload} className="mr-2" />
                {t(
                  "SingleExamination.ConfigurationTab.WebConfiguration.SEBConfigurationDownload"
                )}
              </Button>
            </div>
          </>
        ) : (
          ""
        )}
      </>
    );
  }
}

export default withTranslation()(SEBSettingsSection);
